export const environment = {
  // apiUrl: 'http://localhost:5000/api'
   apiUrl: 'https://careerplanacademy.in/api'
};
